import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
} from "@mui/material";
import { useTranslation } from "react-i18next";
import { v4 as uuidv4 } from "uuid";

import ProceedButton from "../../buttons/proceedButton/ProceedButton";
import "./AddItemDialog.scss";

interface AddItemDialogProps {
  isOpen: boolean;
  title: string;
  formData: any;
  itemToEdit: any;
  isFormValid: boolean;
  closeDialog: () => void;
  onSave: (item: any) => void;
  className?: string | undefined;
}

const AddItemDialog = (props: React.PropsWithChildren<AddItemDialogProps>) => {
  const { t } = useTranslation();
  const {
    isOpen,
    title,
    formData,
    isFormValid,
    children,
    closeDialog,
    onSave,
    itemToEdit,
    className,
  } = props;

  const handleSave = () => {
    if (itemToEdit) onSave(formData);
    else onSave({ ...formData, id: uuidv4() }); // Add new item with new id

    closeDialog();
  };

  const handleClose = (event: object, reason: string) => {
    // do not close it when clicking outside the dialog
    if (reason !== "backdropClick") {
      closeDialog();
    }
  };

  return (
    <Dialog
      className={"add-item-dialog " + className}
      open={isOpen}
      onClose={handleClose}
    >
      <DialogTitle>{title}</DialogTitle>
      <DialogContent>{children}</DialogContent>
      <DialogActions>
        <Button onClick={closeDialog} color="primary">
          {t("cancel")}
        </Button>
        <ProceedButton
          value={itemToEdit ? t("save") : t("add")}
          disabled={!isFormValid}
          onProceed={handleSave}
          variant="contained"
        />
      </DialogActions>
    </Dialog>
  );
};

export default AddItemDialog;
